import { render, staticRenderFns } from "./BeeListItem.vue?vue&type=template&id=21648b06&"
import script from "./BeeListItem.vue?vue&type=script&lang=js&"
export * from "./BeeListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports